import React from 'react';
import { Select, MenuItem } from '@material-ui/core';
import { useQuery } from '@apollo/react-hooks';
import { ROUND_TYPE } from '../../hasura/queries/round/roundType';
import { InlineProgress } from '../util/progress';
import { Error } from '../util/notifications';

const RoundType = ({ overrideChange, currentValue, columnKey, ...props }) => {
  const { loading, error, data } = useQuery(ROUND_TYPE, {});

  if (loading) return <InlineProgress />;

  const items = data?.statsbomb_round_type || [];

  return (
    <>
      <Error message="Error fetching Round Types" error={error} />

      <Select
        error={!currentValue}
        onChange={e => overrideChange(columnKey, e.target.value)}
        value={currentValue || 0}
        {...props}>
        <MenuItem value="0" disabled>
          Round Type
        </MenuItem>
        {items.map((item, key) => (
          <MenuItem key={key} value={item.round_type_id}>
            {item.round_type_name}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export { RoundType };
